import type { ProductHit } from '@libs/algolia';
import { isLocaleCA } from '@libs/core';

export const isAutoshipBadgeEligible = (product: ProductHit): boolean => {
    if (!product.isSubscriptionEnabled) return false;

    const isInStoreOnly = product['shoppingOptions-isInStoreOnly'] || product['shoppingOptions-isInStoreOnlyOverride'];

    const isSthEligible = !isInStoreOnly && (!isLocaleCA() || !!product['shipToHome-isCASupported']);

    if (isSthEligible) return true;

    return !product.AS_Override;
};
